/* @flow */
import React from 'react';
import { Dropdown } from 'antd';
import classNames from 'classnames';
import styles from './styles.module.pcss';

type Props = {
  overlayClassName?: string,
};

const HeaderDropdown = ({ overlayClassName: cls, ...restProps }: Props) => (
  <Dropdown {...restProps} overlayClassName={classNames(styles.container, cls)} />
);

export default HeaderDropdown;
